import { render, staticRenderFns } from "./ShapeStyle.vue?vue&type=template&id=52091104"
import script from "./ShapeStyle.vue?vue&type=script&lang=js"
export * from "./ShapeStyle.vue?vue&type=script&lang=js"
import style0 from "./ShapeStyle.vue?vue&type=style&index=0&id=52091104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports